import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {authenticationService} from '../_services/authentication.service';
import {userService} from '../_services/user.service';
export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => {
        const currentUser = userService.getLoggedInUser();
        if (!currentUser) {
            // not logged in so redirect to login page with the return url
            return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        }

        // authorised so return component
        return <Component {...rest} {...props} />
    }} />
)